import type {RouteLocationNormalized} from 'vue-router';
import {defineNuxtRouteMiddleware, navigateTo} from '#imports';

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    // We don't override the query params if the destination already contains query params
    if (to.fullPath === from.fullPath || Object.keys(from.query).length === 0 || Object.keys(to.query).length > 0) {
        return;
    }

    return navigateTo({
        ...to,
        query: from.query,
    });
});
